/* import __COLOCATED_TEMPLATE__ from './pipedrive-hovercard.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();